const productInit = (product: HTMLElement) => {
  const productLinks: NodeListOf<HTMLAnchorElement> = product.querySelectorAll('.woocommerce-loop-product__link');

  [...productLinks].forEach((item: HTMLAnchorElement) => {
    item.addEventListener('click', (event) => {
      const innerItem = item;

      const target = event.target as HTMLElement;
      if (target.classList.contains('product-archive__color') || target.classList.contains('product-archive__colors')) {
        event.preventDefault();
      }

      if (target.classList.contains('product-archive__color')) {
        const { image } = target.dataset;
        const { url } = target.dataset;
        const imageElement = product.querySelector('img') as HTMLImageElement;
        imageElement.srcset = image;
        imageElement.src = image;
        innerItem.href = url;
      }
    });
  });
};

export default productInit;
